module.exports = __webpack_public_path__ + "img/evaluate-no1.7a3ffec7.png";